import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Shows a Bootstrap modal rendered into the layout's "modal" turbo-frame, and clears
// the frame when the modal is dismissed so the same link can be opened again.
export default class extends Controller {
  connect() {
    this.modal = Modal.getOrCreateInstance(this.element)
    this.element.addEventListener("hidden.bs.modal", this.clear)
    this.modal.show()
  }

  // Also runs when the frame content is replaced (e.g. a form re-rendered with errors),
  // in which case the old backdrop must go before the replacement modal shows its own.
  disconnect() {
    this.element.removeEventListener("hidden.bs.modal", this.clear)
    this.modal?.dispose()
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("padding-right")
  }

  hide() {
    this.modal.hide()
  }

  clear = () => {
    const frame = this.element.closest("turbo-frame")
    if (frame) {
      frame.removeAttribute("src")
      frame.innerHTML = ""
    }
  }
}
